import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    Container,
    Typography,
    Button,
    CircularProgress
} from '@material-ui/core';

import {
    FieldError
} from '../../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    CheckboxWithLabel
} from 'formik-material-ui';

import {
    SelectAsync
} from '../../../../common/formik';

import { PageContext } from '../PageContext';

import AddIcon from '@material-ui/icons/Add'

import { makeStyles } from '@material-ui/core/styles';
import { map } from 'lodash';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(3),
    },
    title: {
        fontWeight: "bold"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    progress: {
        color: "black"
    }
}));

export const SelectUserForm = ({
    formRef,
    errors,
    disabled,
    onSearchUsers,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        table
    } = state;

    const {
        roles,
        users
    } = table;

    const getInitialValues = () => {
        return {
            userId: "",
            roleIds: []
        };
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
    }

    const loadOptionsHandler = (value, callback) => {
        if (onSearchUsers) onSearchUsers(value, callback);
    }

    return (
        <div className={clsx(classes.root, props.className)}>
            <Typography variant="h5" className={classes.title}>
                Add an user from Active Directory
            </Typography>
            <Container maxWidth="lg" className={classes.content}>
                <Formik
                    enableReinitialize
                    initialValues={getInitialValues()}
                    onSubmit={submitClickHandler}
                    innerRef={formRef}>
                    {(props) => {
                        const { values, isSubmitting, handleSubmit } = props;
                        return (
                            <Form noValidate autoComplete="off">
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Field
                                            className={classes.field}
                                            name="userId"
                                            type="text"
                                            label="Search an user"
                                            placeholder="Type an user name or email..."
                                            disabled={disabled}
                                            component={SelectAsync}
                                            loadOptions={loadOptionsHandler}
                                            getOptionLabel={option => `${option.displayName} (${option.mail})`}
                                            getOptionValue={option => option.id}
                                        />
                                        <FieldError name="name" errors={errors} />
                                    </Grid>
                                    <Grid container item xs={12}>
                                        {roles && roles.map((role, index) =>
                                            <Grid key={index} item xs={12}>
                                                <Field
                                                    type="checkbox"
                                                    name="roleIds"
                                                    value={role.roleId.toString()}
                                                    component={CheckboxWithLabel}
                                                    Label={{ label: role.roleName }}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                    <Grid container item justifyContent="flex-end" xs={12}>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            disabled={disabled || isSubmitting || values.userId === "" || values.roleIds.length === 0}
                                            onClick={() => handleSubmit()}>
                                            {isSubmitting ?
                                                <><CircularProgress size={20} className={classes.progress} />&nbsp;&nbsp;Add User</>
                                                :
                                                <><AddIcon />&nbsp;Add User</>
                                            }
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Form>
                        );
                    }}
                </Formik>
            </Container>
        </div>
    );
}